export default {
      id: "mirror-usage",
      viewBox: "0 0 44.75 64.94",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#mirror",
      toString: function () {
        return this.url;
      }
    }